const dateMiniuteHourFormat = 'YYYY-MM-DD hh:mm:ss';
export default dateMiniuteHourFormat;
